module.exports = __webpack_public_path__ + "img/Mstorybg404.d8c8996e.png";